import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Context
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';

// Layout components (cargados inmediatamente)
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import AnnouncementBanner from './components/AnnouncementBanner';

// Páginas críticas (cargadas inmediatamente)
import HomePage from './pages/HomePage';
import ProductosPage from './pages/ProductosPage';
import ProductoDetailPage from './pages/ProductoDetailPage';

// Páginas secundarias (lazy loading - reducen JS inicial)
const ContactoPage = lazy(() => import('./pages/ContactoPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const PaymentSuccessPage = lazy(() => import('./pages/PaymentSuccessPage'));
const PaymentErrorPage = lazy(() => import('./pages/PaymentErrorPage'));
const PaymentPendingPage = lazy(() => import('./pages/PaymentPendingPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const AuthCallbackPage = lazy(() => import('./pages/AuthCallbackPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));
const PresentacionPage = lazy(() => import('./pages/PresentacionPage'));

// Loading fallback minimalista
const PageLoader = () => (
  <div className="min-h-[50vh] flex items-center justify-center bg-[#EFE1C4]">
    <div className="w-8 h-8 border-2 border-[#7A5A2E] border-t-transparent rounded-full animate-spin" />
  </div>
);

// Layout wrapper that hides header/footer on admin and auth pages
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isAuthPage = location.pathname === '/login' || 
                     location.pathname.startsWith('/auth/') ||
                     location.pathname === '/olvide-contrasena' ||
                     location.pathname === '/restablecer-contrasena';

  if (isAdmin || isAuthPage) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#EFE1C4]">
      <AnnouncementBanner />
      <Header />
      <CartDrawer />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Layout>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
} />
                <Route path="/presentacion" element={<PresentacionPage />} />
                <Route path="/productos" element={<ProductosPage />} />
                <Route path="/productos/:slug" element={<ProductoDetailPage />} />
} />
                <Route path="/contacto" element={<ContactoPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/pago/exito" element={<PaymentSuccessPage />} />
                <Route path="/pago/error" element={<PaymentErrorPage />} />
                <Route path="/pago/pendiente" element={<PaymentPendingPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/mi-cuenta" element={<ProfilePage />} />
                <Route path="/auth/callback" element={<AuthCallbackPage />} />
                <Route path="/olvide-contrasena" element={<ForgotPasswordPage />} />
                <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />
              </Routes>
            </Suspense>
          </Layout>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
